(function() {
    'use strict';

    angular.module('app.horarios', []);
})();
